/**
 * Guide for use feature flag
 * 1.Add new feature flag:
 *      First need add the key to FEATURE_FLAGS in packages/rwc-utils/src/constants/feature-flags.ts
 *      If the flag data sources is FFS, add the key to FFS_FEATURE_FLAGS
 * 2.Get a flag by key:
 *      Use `.getFlag(key)` as before, calculates a feature flag object based on values from app.config, localStorage, sessionStorage,and ffs flags
 *      Use `.getRemoteFeatureFlag` get the pure flag value from remote(FFS), will ignore the app.config
 */
import { FeatureFlagModule } from '@ringcentral/rwc-utils/src/feature-flag/feature-flag-module';
import rwcInternalApi, { intApiFeatureFlagClient } from './internal-api';

//TODO temp solution, please remove it after fixing MF issue
const featureFlagClientSymbol = Symbol.for('FeatureFlagClient');
let featureFlagClient: FeatureFlagModule;
if (typeof window === 'object') {
    if (!window[featureFlagClientSymbol]) {
        window[featureFlagClientSymbol] = new FeatureFlagModule();
        rwcInternalApi.register(intApiFeatureFlagClient, window[featureFlagClientSymbol]);
    }

    featureFlagClient = window[featureFlagClientSymbol];
} else {
    featureFlagClient = new FeatureFlagModule();
}
export { featureFlagClient };
